import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** Aside-rail icon for the Marketing section (megaphone). */
const IconMarketing: React.FC<IconProps> = ({
  size = 20,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M3 11v2a1 1 0 0 0 1 1h2.4L18 20V4L6.4 10H4a1 1 0 0 0-1 1Z" />
    <path d="M18 8.5a3.5 3.5 0 0 1 0 7" />
    <path d="M7 14.5V19a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-2.3" />
  </svg>
);

export default IconMarketing;
